import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconMail = forwardRef<SVGSVGElement, IconProps>(function IconMail(
  props,
  ref,
) {
  const { className, title, titleId, ...otherProps } = props
  const defaultClasses =
    "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <svg
      ref={ref}
      viewBox="0 0 32 32"
      fill="none"
      focusable="false"
      aria-hidden="true"
      tabIndex={-1}
      className={classes}
      aria-labelledby={titleId}
      {...otherProps}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0989 31.4329C22.5389 31.5529 23.0189 31.5929 23.4589 31.5929C24.5789 31.5929 25.6589 31.2329 26.5789 30.5929C27.8989 29.5929 28.6189 28.1129 28.6189 26.4729V9.59294C28.6189 7.23294 27.0189 5.19294 24.7789 4.59294L9.8989 0.592941C8.3389 0.152941 6.6989 0.472941 5.4189 1.47294C4.0989 2.47294 3.37891 3.95294 3.37891 5.59294V22.4329C3.37891 24.7929 4.9789 26.8329 7.2189 27.4329L22.0989 31.4329ZM6.17891 2.43294C6.85891 1.87294 7.69891 1.59294 8.57891 1.59294C8.89891 1.59294 9.2589 1.63294 9.6189 1.71294L24.4989 5.71294C26.2589 6.19294 27.4589 7.75294 27.4589 9.55294V10.9495L14.3393 18.4699L4.63228 5.26196C4.72273 4.14839 5.26846 3.12488 6.17891 2.43294ZM4.6189 7.1551L13.6493 19.6099C13.7057 19.6871 13.7794 19.7499 13.8645 19.7933C13.9496 19.8367 14.0437 19.8595 14.1393 19.8599C14.2412 19.8583 14.341 19.8308 14.4293 19.7799L27.4589 12.3768V26.4729C27.4589 27.7129 26.8989 28.8729 25.8989 29.6329C24.8989 30.3929 23.6589 30.6329 22.4589 30.3129L7.57891 26.3129C5.81891 25.8329 4.6189 24.2729 4.6189 22.4729V7.1551Z"
        fill="currentColor"
      />
    </svg>
  )
})
